module.exports = __webpack_public_path__ + "static/img/1_5.a896b23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new/1_5.png
// module id = 8woH
// module chunks = 0